import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// P8 — new & returning (both segments active). Real numbers from Sweet Water Decor
// (b_1b0f6a45), anonymized. Review window: 3 months (Apr–Jun 2026); rollout extends to ~20mo.
export const advP8NewReturning: FaireAdvertiserProfileEntity = {
  token: "adv_p8_new_returning",
  type: "advertiserProfile",
  archetype: "new-and-returning",
  displayName: "Marigold & Main",
  brandToken: "b_adv_p8_new_returning",
  audienceType: "NEW_AND_RETURNING",
  globalStatus: "ACTIVE",
  tenureMonths: 24,
  budget: {
    totalBudgetDollars: 15000,
    spendingMode: "COMPETITIVE",
    nextRenewsAtDate: "2026-08-01",
    nextBillsAtDate: "2026-08-04",
  },
  overview: {
    numCustomersAcquired: 129,
    numReorderConversions: 393,
    numTotalConversions: 522,
    totalAdsSalesDollars: 174215,
    newCustomerAdsSalesDollars: 57977,
    reorderAdsSalesDollars: 116238,
    totalAdsSpendDollars: 31623,
    newCustomerAdsSpendDollars: 11625,
    reorderAdsSpendDollars: 19998,
    newCustomerBestEstimateFirstYearRoas: 4.99,
    reorderRoas: 5.81,
    combinedFirstYearRoas: 5.51,
  },
  availableCredit: {
    totalRemainingDollars: 0,
  },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 6000,
      maxRecommendedBudgetDollars: 9000,
    },
    reorder: {
      minRecommendedBudgetDollars: 9000,
      maxRecommendedBudgetDollars: 12000,
    },
  },
  campaignTokens: ["camp_p8_nr_new", "camp_p8_nr_reorder"],
  overviewPerformancePeriodTokens: [
    "perf_p8_nr_ovw_202604",
    "perf_p8_nr_ovw_202605",
    "perf_p8_nr_ovw_202606",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
